/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { EstimatedDuration } from '../enums/estimated-duration';
import { FocusArea } from '../enums/focus-area';
import { Industry } from '../enums/industry';
import { LegalTeamSize } from '../enums/legal-team-size';
import { LevelOfExperience } from '../enums/level-of-experience';
import { LicensedLawyer } from '../enums/licensed-lawyer';
import { StateCode } from '../enums/state-code';
import { Urgency } from '../enums/urgency';
import { AccountEntity } from './account-entity';
import { LanguageEntity } from './language-entity';
import { OpportunityEntity } from './opportunity-entity';
export class DigitalIntakeDetailEntity extends Entity {
  account: AccountEntity | null = null;
  accountId: string = '';
  additionalDetailsForTalent: string | null = null;
  companyLocation: Record<string, unknown> | null = null;
  createdAt: string | null = null;
  dsSuggestedId: string | null = null;
  estimatedDuration: EstimatedDuration | null = null;
  generalSkills: string[] | null = null;
  id: string = '';
  industry: Industry | null = null;
  instantMatchesRefreshedAt: string | null = null;
  language: LanguageEntity | null = null;
  languageId: string | null = null;
  legalSkills: string[] | null = null;
  legalTeamSize: LegalTeamSize | null = null;
  legalTechSkills: string[] | null = null;
  levelOfExperience: LevelOfExperience | null = null;
  licensedLawyer: LicensedLawyer | null = null;
  licensedLawyerState: StateCode | null = null;
  opportunity: OpportunityEntity | null = null;
  opportunityId: string | null = null;
  otherFocusAreas: string[] | null = null;
  primaryFocusArea: FocusArea | null = null;
  startDate: string | null = null;
  updatedAt: string | null = null;
  urgency: Urgency | null = null;
  static override key = 'DigitalIntakeDetail';
  static override get schema() {
    return {
      account: AccountEntity,
      language: LanguageEntity,
      opportunity: OpportunityEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'DigitalIntakeDetail' in input
    ) {
      const { DigitalIntakeDetail: wrapped, ...rest } = input as {
        DigitalIntakeDetail: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}